export const COLOR_PALETTE: readonly string[] = [
  "#ff7a45",
  "#ffd166",
  "#57cc99",
  "#4cc9f0",
  "#ef476f",
  "#9b5de5",
  "#f15bb5",
  "#00bbf9",
];

export const STICKER_SET: readonly string[] = [
  "⭐",
  "❤️",
  "🌈",
  "🌸",
  "🦋",
  "🎈",
  "🍎",
  "🐱",
];
